import { useQuery } from "@tanstack/react-query";

import { getReportTemplate, ReportTemplate } from "@services/reportEngine";

export const useReportTemplate = (id?: string) => {
  return useQuery<ReportTemplate>(
    ["reportTemplate", id],
    () => getReportTemplate(id!),
    { enabled: Boolean(id), refetchOnWindowFocus: false },
  );
};
